import { Box } from '@apia/theme';
import { useBoolean, useUpdateEffect } from 'ahooks';
import React from 'react';
import shortcutController from '../../classes/shortcutController';
import debugDispatcher from '../../utils/debugDispatcher';
import persistentStorage from '../../utils/persistentStorage';
import JSONAccordion from '../apia/execution/common/JSONAccordion';
import fieldsStore from '../apia/execution/fieldsStore/fieldsStore';
import CollapsiblePanel from './CollapsiblePanel';
import ConfirmModal from './dialogs/modals/ConfirmModal';
import EventEmitter from '../../utils/util/eventEmitter';

export interface IDebugInfo {
  id: string;
  data?: unknown[] | Record<string, unknown> | null;
}

let debugSize = 0;
export const debugSizeEmitter = new (class extends EventEmitter<{
  debugSize: number;
}> {})();

debugDispatcher.on(
  'debugSize',
  ([newSize]) => {
    persistentStorage.debugSize = newSize;
    debugSize = newSize as number;
    debugSizeEmitter.emit('debugSize', debugSize);
  },
  'Permite pasar un parámetro de tipo string que define el tamaño en pixels del botón de debug de formularios. Ejemplo: dd.debugSize(10)',
);
shortcutController.on(['shift&D', ...'info'.split('')], () => {
  const size = persistentStorage.debugSize ? 0 : 10;
  persistentStorage.debugSize = size;
  debugSizeEmitter.emit('debugSize', size);
});

const DebugInfo = ({ id, data }: IDebugInfo) => {
  const [isToggled, { setTrue, setFalse }] = useBoolean(false);

  const [size, setSize] = React.useState(debugSize);

  React.useEffect(() => {
    const storedSize = persistentStorage.debugSize;
    if (storedSize !== undefined && storedSize !== size)
      setSize(storedSize as number);

    const unregister = debugSizeEmitter.on('debugSize', setSize);

    return () => {
      unregister();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useUpdateEffect(() => {
    persistentStorage.debugSize = size;
  }, [size]);
  // const keys = Array.from(id) as Hotkey[];

  const getDebugData = (): JSX.Element => {
    return (
      <main
        sx={{
          '*': {
            resize: 'both',
          },
          '.collapsiblePanel__label': {
            fontWeight: 'bold',
            width: '100%',
          },
          '.collapsiblePanel:hover': {
            '& > .collapsiblePanel__label': {
              bg: 'rgba(0,0,0,0.1)',
            },
          },
        }}
      >
        <Box>
          <Box as="strong">Value:</Box>
          {JSON.stringify(fieldsStore.getById(id)?.getValue())}
        </Box>

        <CollapsiblePanel collapsed id="Data" label="Data">
          <JSONAccordion obj={data as unknown as Record<string, unknown>} />
        </CollapsiblePanel>
      </main>
    );
  };

  if (size === 0 || !data) return null;

  return (
    <Box>
      <Box
        role="button"
        className="debug_info__button"
        tabIndex={-1}
        onClick={setTrue}
        onKeyDown={() => {}}
        sx={{
          bg: 'blue',
          width: size,
          height: size,
          cursor: 'pointer',
        }}
      />
      <ConfirmModal
        isOpen={isToggled}
        onExited={setFalse}
        size="xxxl"
        sx={{
          '.modal__title': {
            userSelect: 'text',
          },
        }}
      >
        {getDebugData()}
      </ConfirmModal>
    </Box>
  );
};

export default DebugInfo;
